/* eslint-disable react/jsx-one-expression-per-line */
import { MainLayout } from 'layouts'

import style from './TermsOfUse.module.scss'

export const TermsOfUse = () => {
  return (
    <MainLayout>
      <div className='container'>
        <section className={style.termOfUse}>
          <h1>Пользовательское соглашение</h1>
          <h4>1. Термины и определения</h4>
          <ul>
            <li>
              <span className={style.termOfUse__num}>1.1</span>
              Сервис — автоматизированная информационная система, расположенная
              на сайте{' '}
              <a href='https://lk.doorhan.ru/'>https://lk.doorhan.ru/</a>,
              предназначенная для оформления Заказчиком заявок на расчет,
              изготовление и монтаж изделий.
            </li>
            <li>
              <span className={style.termOfUse__num}>1.2</span>
              Заказчик — физическое или юридическое лицо, использующее Сервис
              для подачи Заявки.
            </li>

            <li>
              <span className={style.termOfUse__num}>1.3</span>
              Заявка — оформленное через Сервис волеизъявление Заказчика на
              получение коммерческого предложения и последующее заключение
              договора.
            </li>
            <li>
              <span className={style.termOfUse__num}>1.4</span>
              Коммерческое предложение (КП) — документ, содержащий расчет
              стоимости, спецификацию и условия оказания услуг, сформированный
              на основе данных, полученных в ходе замера.
            </li>
            <li>
              <span className={style.termOfUse__num}>1.5</span>
              Производитель/Агент — DoorHan, выступающее организатором Сервиса и
              агентом по заключению договоров от имени и за счет Исполнителей
              (Дилеров).
            </li>
            <li>
              <span className={style.termOfUse__num}>1.6</span>
              Исполнитель/Дилер — третье лицо, привлекаемое Производителем для
              выполнения замера, монтажа и иных обязательств по Заявке.
            </li>
          </ul>

          <h4>2. Условия использования сайта</h4>

          <ul>
            <li>
              <span className={style.termOfUse__num}>2.1</span>
              Все материалы, размещенные на сайте, являются собственностью
              компании DoorHan и охраняются в соответствии с главой 69 ГК РФ о
              правах интеллектуальной деятельности, включая авторское право.
              Копирование любой информации и материалов без согласования с
              владельцами сайта запрещено.
            </li>
            <li>
              <span className={style.termOfUse__num}>2.2</span>
              Регистрируясь на сайте или оставляя иным способом личную
              информацию, вы соглашаетесь на обработку своих персональных
              данных.
            </li>
          </ul>

          <h4>3. Порядок взаимодействия</h4>

          <ul>
            <li>
              <span className={style.termOfUse__num}>3.1</span>
              <span className={style.termOfUse__title}>Оформление Заявки.</span>
              <br />
              Заказчик инициирует процесс, заполняя соответствующую веб-форму на
              Сайте Сервиса, выражая тем самым согласие с условиями настоящего
              Регламента. Заказчик обязуется предоставить достоверную контактную
              информацию.
            </li>
            <li>
              <span className={style.termOfUse__num}>3.2</span>
              <span className={style.termOfUse__title}>Замер объекта.</span>
              <br />
              После регистрации Заявки Производитель поручает одному из
              аккредитованных Исполнителей (Дилеров) связаться с Заказчиком для
              согласования времени и даты проведения бесплатного замера
              параметров объекта. Проведение замера означает согласие Заказчика
              на последующую подготовку КП.
            </li>
            <li>
              <span className={style.termOfUse__num}>3.3</span>
              <span className={style.termOfUse__title}>
                Формирование и акцепт Коммерческого предложения.
              </span>
              <br />
              На основании данных замера в Личном кабинете (ЛК) Заказчика
              формируется Коммерческое предложение (КП). Ознакомление с КП и его
              оплата через функционал Сайта признаются полным и безоговорочным
              акцептом (принятием) оферты Заказчика со стороны Производителя и
              Исполнителя. С этого момента считается, что договор на оказание
              услуг заключен.
            </li>
            <li>
              <span className={style.termOfUse__num}>3.4</span>
              <span className={style.termOfUse__title}>
                Оплата и отслеживание статуса.
              </span>
              <br />
              Заказчик имеет возможность произвести оплату принятого КП онлайн с
              использованием платежных средств, доступных на Сайте. Информация о
              статусе выполнения обязательств по Заявке предоставляется в режиме
              реального времени через Личный кабинет Заказчика.
            </li>
          </ul>

          <h4>4. Заключительные положения</h4>

          <span className={style.termOfUse__lastBlock}>
            Производитель гарантирует, что к выполнению Заявок привлекаются
            исключительно проверенные Исполнители (Дилеры), соответствующие
            стандартам и требованиям Производителя.
          </span>
        </section>
      </div>
    </MainLayout>
  )
}
